export default __webpack_public_path__ + "static/Design-wireframe-7c6e9b63a53674fda1188c84675a89ad.png";